"use strict";

exports.__esModule = true;
exports.ScatterPlotChartRadiusPicker = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _Translator = require("../../../Core/Translator");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var RadiusSelector = (0, _styledComponents["default"])(_core.NumericInput).withConfig({
  displayName: "ScatterPlotChartRadiusPicker__RadiusSelector",
  componentId: "sc-i8eg7d-0"
})([".", "{width:75px;}"], _core.Classes.INPUT_GROUP);
var ScatterPlotChartRadiusPicker = exports.ScatterPlotChartRadiusPicker = function ScatterPlotChartRadiusPicker(_ref) {
  var radius = _ref.radius,
    handleRadiusChange = _ref.handleRadiusChange;
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("ScatterPlotChartRadiusPicker.Radius", "Radius"),
    helperText: translate("ScatterPlotChartRadiusPicker.helperText", "Change the dot radius")
  }, /*#__PURE__*/_react["default"].createElement(RadiusSelector, {
    value: radius,
    onValueChange: handleRadiusChange,
    min: 1
  }));
};